<template>
  <div class="contract_print_dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="1000px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body" ref="print">
        <div class="order-list" v-for="(item, i) in dataList" :key="i">
          <p class="date">{{ now }} {{ item.customShipmentNum ? `${item.customShipmentNum}` : '' }}</p>
          <div class="title-box">
            <h3 v-if="item.orderClass === 'lease'">{{ $t('crm_contractDownload.zu_lin_fa_huo_dan') }}</h3>
            <h3 v-if="item.orderClass === 'order'">{{ $t('crm_contractDownload.xie_yi_fa_huo_dan') }}</h3>
            <h3 v-if="item.orderClass === 'sale'">{{ $t('crm_contractDownload.zu_shou_fa_huo_dan') }}</h3>
            <h3 v-if="item.orderClass === 'trial'">{{ $t('crm_contractDownload.shi_yong_fa_huo_dan') }}</h3>
            <h3 v-if="item.orderClass === 'transfer'">{{ $t('crm_contractDownload.tiao_bo_fa_huo_dan') }}</h3>
            <!-- <h3>{{ $t('page_contract_zlhtfhd') }}</h3> -->
            <div class="qr-code-content" v-if="item.u8DeliveryCodeStr">
              <qrcode-vue :value="item.u8DeliveryCodeStr" :size="50" render-as="svg"></qrcode-vue>
            </div>
          </div>
          <table border="1" style="border-collapse: collapse" class="table">
            <template v-if="item.orderClass === 'transfer'">
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.shou_huo_zu_zhi') }}</th>
                <th colspan="3" class="val">{{ item.consigneeOrgName || '-' }}</th>
              </tr>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.he_tong_bian_hao') }}</th>
                <th class="val" colspan="3">{{ item.contractNo || '-' }}</th>
              </tr>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.shou_huo_ren') }}</th>
                <th class="val w30">{{ item.consigneeName || '-' }}</th>
                <th class="val w20">{{ $t('crm_contractDownload.shrdh') }}</th>
                <th class="val w30">{{ item.consigneePhone || '-' }}</th>
              </tr>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.shou_huo_di_zhi') }}</th>
                <th class="val" colspan="3">{{ item.consigneeAddress }}</th>
              </tr>
            </template>
            <template v-else>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.jfsqdb') }}</th>
                <th colspan="3" class="val">{{ item.partyAName || '-' }}</th>
              </tr>
              <tr v-if="item.orderClass === 'trial'">
                <th class="key w20">{{ $t('crm_contractDownload.ding_dan_bian_hao') }}</th>
                <th class="val w30">{{ item.contractNo || '-' }}</th>
                <th class="val w20">{{ $t('crm_contractDownload.qian_ding_ri_qi') }}</th>
                <th class="val w30">{{ $momentLocal(item.signingDate, 'YYYY-MM-DD') || '-' }}</th>
              </tr>
              <tr v-else>
                <th class="key w20">{{ $t('crm_contractDownload.he_tong_bian_hao') }}</th>
                <th class="val w30">{{ item.contractNo || '-' }}</th>
                <th class="val w20">{{ $t('crm_contractDownload.sghth') }}</th>
                <th class="val w30">{{ item.customContractNo || '-' }}</th>
              </tr>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.shou_huo_ren') }}</th>
                <th class="val w30">{{ item.consigneeName || '-' }}</th>
                <th class="val w20">{{ $t('crm_contractDownload.shrdh') }}</th>
                <th class="val w30">{{ item.consigneePhone || '-' }}</th>
              </tr>
              <tr>
                <th class="key w20">{{ $t('crm_contractDownload.shou_huo_di_zhi') }}</th>
                <th class="val" colspan="3">
                  {{ item.consigneeAddress }}
                </th>
              </tr>
            </template>

            <!-- <tr>
            <th class="key w20">{{ $t('page_contract_ddlx') }}</th>
            <th class="val w30">{{ getDicValue('crm_contract_type',item.orderType)  || '-' }}</th>
            <th class="val w20">{{ $t('page_contract_qian_ding_ri_qi_1') }}</th>
            <th class="val w30">{{ $momentLocal(item.signingDate, 'YYYY-MM-DD') || '-' }}</th>
          </tr> -->

            <tr>
              <th class="key w20">{{ $t('crm_contractDownload.wu_liu_gong_si') }}</th>
              <th class="val w30">{{ item.logisticsCompanyName }}</th>
              <th class="val w20">{{ $t('crm_contractDownload.jie_suan_fang_shi') }}</th>
              <th class="val w30">{{ $t('crm_contractDownload.dao_fu') }}</th>
            </tr>
            <tr>
              <th class="key">{{ $t('crm_contractDownload.huo_wu_ti_ji') }}</th>
              <th class="val">{{ item.totalVolume }} m³</th>
              <th class="val">{{ $t('crm_contractDownload.fa_huo_shi_jian') }}</th>
              <th class="val">{{ momentAmPm($momentLocal(item.shipperTime)) }}</th>
            </tr>
            <tr>
              <th class="key">{{ $t('crm_contractDownload.cpxhcpSN') }}</th>
              <th class="val">{{ $t('crm_contractDownload.she_bei_lei_xing') }}</th>
              <th class="val">{{ $t('crm_contractDownload.fa_huo_shu_liang') }}</th>
              <th class="val">{{ $t('crm_contractDownload.jhfhsb') }}</th>
            </tr>
            <tr v-for="(pitem, index) in item.goodsList" :key="index">
              <th class="key">
                {{ pitem.productCode }}
                <span v-if="pitem.productSns">/{{ pitem.productSns }}</span>
              </th>
              <th class="val">{{ pitem.deviceBizType }}</th>
              <th class="val">{{ pitem.deviceNum }}</th>
              <th class="val">{{ pitem.bodyNum }}</th>
            </tr>
            <tr>
              <th class="key">{{ $t('crm_contractDownload.zong_ji') }}</th>
              <th class="val"></th>
              <th class="val">{{ item.totalDeviceNum }}</th>
              <th class="val"></th>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
/**
 *
 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import QrcodeVue from 'qrcode.vue';
import moment from 'moment';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    QrcodeVue,
  },
  data() {
    return {
      dataList: [],
      isLoading: false,
      // deviceList: [],
    };
  },
  computed: {
    now() {
      return moment().format('YYYY-MM-DD');
    },
    // bookingNumTotal() {
    //   return this.deviceList.reduce((total, item) => total + Number(item['bookingNum'] || 0), 0);
    // },
    // hqNeedShipNumTotal() {
    //   return this.deviceList.reduce((total, item) => total + Number(item['hqNeedShipNum'] || 0), 0);
    // },
  },

  methods: {
    getOrderClass(item) {
      // 订单类型，transfer-调拨 lease-租赁 order-销售 trial-试用
      let orderClass = '';
      const bizClass = item.contractType;
      if (['10', '20', '30'].includes(`${bizClass}`)) {
        orderClass = 'lease';
      } else if (['40'].includes(`${bizClass}`)) {
        orderClass = 'sale';
      } else if (['50'].includes(`${bizClass}`)) {
        orderClass = 'order';
      } else if (['90'].includes(`${bizClass}`)) {
        orderClass = 'transfer';
      } else if (['10'].includes(`${bizClass}`)) {
        orderClass = 'trial';
      }
      return orderClass;
    },
    getPageInfo() {
      this.$getJSON(apis.shipPlanBatchInfo, {
        orderDeliveryId: this.model.data.orderDeliveryId,
      }).then((res) => {
        const data = res.data;
        data.forEach((i) => {
          i.orderClass = this.getOrderClass(i);
          // 体积
          i.totalVolume = i.goodsList.reduce((total, item) => this.$toFixed(total + Number(item['deviceNum'] * JSON.parse(item.cleanWheelParam).productVolume || 0)), 0);
          // 设备数量
          i.totalDeviceNum = i.goodsList.reduce((total, item) => this.$toFixed(total + Number(item['deviceNum'] || 0)), 0);
        });

        this.dataList = data || [];
        setTimeout(() => {
          this.$print(this.$refs.print);
        }, 1000);
      });
    },
    // 保存新增
    computedPay: function (ele) {
      const periods = this.getPeriods(ele); // 付款期数
      const paymentPeriod = Number.parseInt(ele.paymentPeriod, 10); // 付款周期，0为全款
      const list = this.setPeriodsDate(periods, paymentPeriod, ele);
      // this.$set(ele, 'children', list);
      // ele=(list
      // return ele
      this.deviceList.push(...list);
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
  mounted() {
    this.getPageInfo();
  },
};
</script>

<style lang="scss">
.contract_print_dialog {
  padding: 16px;
  .order-list {
    margin-bottom: 24px;
  }
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;
    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      color: #000;
      line-height: 40px;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;
    border: 1px solid #000;
    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      // width: calc(100% /6);
    }
    // .key{
    //   width: 16%;
    // }
    // .val{
    //   width:28%;
    // }

    .w20 {
      width: 20%;
    }
    .w30 {
      width: 30%;
    }
  }
}
@media print {
  *noprint::after {
    content: '' !important;
  }
  // 去掉页眉 页尾
  .header,
  .footer {
    display: none;
  }
  @page {
    // size: auto; /* auto is the initial value */
    // margin: 3mm; /* this affects the margin in the printer settings */
    size: A4 portrait;
    margin: 1.5cm 0.5cm 0mm;
    font-family: 'SimSun', '宋体' !important;
  }

  html {
    background-color: #ffffff;
    margin: 0px; /* this affects the margin on the html before sending to printer */
    font-family: 'SimSun', '宋体' !important;
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
    font-family: 'SimSun', '宋体' !important;
  }
  .order-list {
    margin-bottom: 24px;
  }
  .date {
    font-size: 14px;
    line-height: 20px;
    color: #000;
  }
  .title-box {
    text-align: center;
    // display: flex;
    // align-items:center ;
    position: relative;
    margin-bottom: 30px;

    h3 {
      padding: 0 12px;
      text-align: center;
      font-size: 22px;
      color: #000;
      line-height: 40px;
      font-weight: normal !important;
      // font-weight: bold !important;
    }
    .qr-code-content {
      position: absolute;
      right: 0;
      top: 0;
      // width:38px;
    }
  }

  table {
    width: 100%;
    border: 1px solid #000;
    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      // font-weight: bold !important;
      // width: calc(100% /6);
    }
    .w20 {
      width: 20%;
    }
    .w30 {
      width: 30%;
    }
  }
}
</style>
